<template>
  <div class="button-with-image">
    <div class="wrapper">
      <router-link :to="route">
        <slot name="image"></slot>
        <Button
          class="button"
          :theme="theme ? theme : 'white'"
        >
          <slot></slot>
        </Button>
      </router-link>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'ButtonWithImage',
  props: ['theme', 'route'],
  components: { Button }
}
</script>

<style lang="scss" scoped>
  .button-with-image {
    display: inline-block;
    margin: 0 0 30px;
    font-size: 0;
    vertical-align: bottom;
    width: 350px;
    max-width: 100%;
  }
  .button-with-image + .button-with-image {
  }
  .wrapper {
    width: 317px;
    max-width: 100%;
    text-align: center;
  }
  .image {
    width: 100%;
    height: auto;
  }
  .image + .button {
    margin-top: 14px;
  }
  .button {
    margin: 0 auto;
    display: block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ButtonWithImage.vue